import moment from 'moment';

export default (val, format = 'YYYY-MM-DD HH:mm:ss') => moment(val).format(format);



// WEBPACK FOOTER //
// ./src/filters/dateFormat.js